import { TPoint } from '../points.model';

const isCarried = (value: unknown): boolean => value !== undefined && value !== null;

const mergeCarriedFields = (previous: TPoint, incoming: TPoint): TPoint => {
  const carriedFields = Object.entries(incoming).filter(([, value]) => isCarried(value));

  return { ...previous, ...Object.fromEntries(carriedFields) };
};

export function preserveLoadedDetailFields(
  existingEntities: TPoint[] | undefined,
  incomingEntities: TPoint[],
): TPoint[] {
  if (!existingEntities?.length) {
    return incomingEntities;
  }

  const previousById = new Map(existingEntities.map((point) => [point._id, point]));

  return incomingEntities.map((point) => {
    const previous = previousById.get(point._id);

    return previous ? mergeCarriedFields(previous, point) : point;
  });
}
